export type Environment = 'LOCAL' | 'DEV' | 'STAGING' | 'DEMO' | 'PROD'

export const currentEnvironment: Environment = (
  process.env.ENV_NAME || 'LOCAL'
).toUpperCase() as Environment

export const fanAppURL =
  process.env.APP_DOMAIN === 'localhost'
    ? `http://localhost:8080`
    : `https://${process.env.APP_DOMAIN}`
